<template>

	<Tile title="Welcome" width="50%" :buttons="[button]" @click="startAssessment">
		<template v-slot:content>
			<p>Te oratio utamur vix. Bahnhof eloquentiam eu per. Principes complectitur Deutsche Mark no. </p>
			<p>Fangs the assessment an!</p>
		</template>
	</Tile>
</template>
<script type="text/javascript">
	import Tile from "@/components/elements/Tile";
	export default {
		name: "AddOrganisation", 
		data: () => {
			return {			
				button: {
					color: "green",
					emit: "click"
				}	
			}
		},
		components: {
			Tile,
		}, 
		methods: {
			startAssessment(){
				this.$router.push({path: `assessment` })
			}
		}
	}
</script>
